import AgentActivity from 'models/agent_activity';
import changeCurrentLocation from 'actions/lib/change_current_location';
import InboxesAdmin from 'models/location/inboxes_admin';
import LoadRoutingGroupAdmin from 'actions/routing_groups/load_routing_group_admin';
import SetAndLogActivity from 'actions/agent_activity/set_and_log_activity';

export default class OpenInboxesAdmin {
  constructor(context) {
    this.context = context;
  }

  run() {
    if (!this.context.stores.appFeatures.get().isEnabled('inboxManagement')) {
      this.context.router.navigateHome();
      return;
    }

    changeCurrentLocation(this.context, InboxesAdmin.create());

    this.context.executeAction(LoadRoutingGroupAdmin);
    this.context.executeAction(SetAndLogActivity, { type: AgentActivity.Type.INBOXES_ADMIN });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/routing_groups/open_inboxes_admin.js